import React from "react";
import RecommendationSetManager from "./RecommendationSetManager";

export default function FrequentlyBookedTogether() {
  return <RecommendationSetManager section="frequently-booked-together" title="Frequently Booked Together" maxSlots={3} textField="title" textLabel="Title" detailField="price" detailLabel="Price" />;
}
